import classNames from "classnames";

import { useCopy } from "components/CopyProvider";
import { CheckIcon, CopyIcon } from "components/Icons";

import styles from "./AccountFormModal.module.scss";

interface Props {
  title: string | null;
  text: string;
  infoToCopy: string;
}

export const InfoSection = (props: Props) => {
  const { title, text, infoToCopy } = props;
  const { copied, handleCopy } = useCopy();
  return (
    <div className={styles.infoSection}>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
      <div
        className={classNames(styles.copyIcon, { [styles.copied]: copied })}
        onClick={() => {
          handleCopy(infoToCopy);
        }}
        data-testid="copy-info-section"
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </div>
    </div>
  );
};
